import avatar from './avatar.svg';
import comingSoon from './coming-soon.svg';
import paymentFailed from './failed.png';
import hrx from './hrx.svg';
import mainLogo from './mainLogo.svg';
import placeholder from './placeholder.svg';
import signature from './signature.svg';
import paymentSuccess from './success.png';
import xLogo from './x-logo.svg';

const IMAGES = {
  hrx,
  xLogo,
  avatar,
  mainLogo,
  signature,
  comingSoon,
  placeholder,
  paymentFailed,
  paymentSuccess,
};

export default IMAGES;
